.defaults {
    color: #000000;
    background-color: #ffffff;
    font-size: 16px;
    font-family: Arial, sans-serif;
}
